import React, {useContext} from 'react';
import { FaCog, FaComment, FaTicketAlt, FaLock } from 'react-icons/fa';
import { GiBasketballBall, GiTennisRacket } from 'react-icons/gi';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';

const Generation = () => {

  const { t } = useContext(LanguageContext);
  const { hasWeeklyOnly } = useAuth();

  const navigate = useNavigate();

  const handleGenerate = () => {
    if (hasWeeklyOnly) {
      navigate('/subscriptions')
      return;
    }
    navigate('/generate-small-odds')
  };

  const handleWinningTickets = () => {
    navigate('/winning-tickets')
  };

  const handleReviews = () => {
    navigate('/reviews')
  };

  // const handleGenerateHighOdds = () => {
  //   navigate('/generate-high-odds')
  // };

  // const handleGenerateFotbal = () => {
  //   console.log("Generate Fotbal Basket Tennis clicked");
  // };

  const handleBasket = () => {
    navigate('/basketpage')
  };

  const handleTennis = () => {
    navigate('/tennispage')
  };

  return (
    <div className="flex flex-col w-full max-w-[400px] my-4 mx-auto space-y-3">
      <div className="flex flex-row gap-3">
        <button
          onClick={handleGenerate}
          className={"flex flex-col items-center justify-center w-1/3 text-white rounded p-2 shadow transition " + (hasWeeklyOnly ? "bg-gray-400 hover:bg-gray-500" : "bg-[#e67e22] hover:bg-orange-600")}
          style={{ minHeight: '100px' }}
        >
          <div className="flex items-center space-x-2 mb-2">
            {hasWeeklyOnly ? <FaLock size={20} /> : <FaCog size={20} />}
            <span className="font-bold">{t('txt.generateNormalOdds')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <FaComment size={20} />
            <FaTicketAlt size={20} />
          </div>
        </button>

        <div className="flex flex-col w-2/3 gap-3">
          <button
            onClick={handleWinningTickets}
            className="bg-[#27ae60] text-white font-bold rounded p-2 shadow hover:bg-green-600 transition flex items-center justify-center"
            style={{ minHeight: '48px' }}
          >
           {t('txt.winningTickets')}
          </button>
          <button
            onClick={handleReviews}
            className="bg-[#27ae60] text-white font-bold rounded p-2 shadow hover:bg-green-600 transition flex items-center justify-center"
            style={{ minHeight: '48px' }}
          >
            {t('txt.reviewsPage')}
          </button>
        </div>
      </div>

      {/* Below: vertical stack of full-width orange buttons */}
      {/*<button*/}
      {/*  onClick={handleGenerateHighOdds}*/}
      {/*  className="bg-[#e67e22] w-full text-white font-bold rounded p-2 shadow hover:bg-orange-600 transition"*/}
      {/*>*/}
      {/*  /!* GENERATE HIGH ODDS *!/*/}
      {/*  {t('txt.generateHighOdds')}*/}
      {/*</button>*/}

        {/*<button*/}
        {/*  onClick={handleGenerateFotbal}*/}
        {/*  className="bg-[#e67e22] w-full text-white font-bold rounded p-2 shadow hover:bg-orange-600 transition"*/}
        {/*>*/}
        {/*  GENERARE FOTBAL BASKET TENNIS*/}
        {/*</button>*/}

        <button
            onClick={handleBasket}
            className="bg-[#e67e22] w-full text-white font-bold rounded p-2 shadow hover:bg-orange-600 transition flex items-center justify-center gap-2"
        >
          {/* BASKET */}
          <GiBasketballBall size={18} />
          {t('txt.basketPredictions')}
        </button>

        <button
            onClick={handleTennis}
            className="bg-[#e67e22] w-full text-white font-bold rounded p-2 shadow hover:bg-orange-600 transition flex items-center justify-center gap-2"
        >
          {/* TENNIS */}
          <GiTennisRacket size={18} />
          {t('txt.tennisPredictions')}
        </button>
      </div>
  );
};

export default Generation;
